module.exports = __webpack_public_path__ + "static/media/GaneshSabale_Resume.b603f5c4.pdf";